const LOAD_DATA_MASTER_DESTINATION_COUNTRY           = 'LOAD_DATA_MASTER_DESTINATION_COUNTRY'
const LOAD_DATA_MASTER_DESTINATION_COUNTRY_SUCCESS   = 'LOAD_DATA_MASTER_DESTINATION_COUNTRY_SUCCESS'
const LOAD_DATA_MASTER_DESTINATION_COUNTRY_FAILED    = 'LOAD_DATA_MASTER_DESTINATION_COUNTRY_FAILED'
const UNMOUNT_DATA_MASTER_DESTINATION_COUNTRY        = 'UNMOUNT_DATA_MASTER_DESTINATION_COUNTRY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterDestinationCountryReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_DESTINATION_COUNTRY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_DESTINATION_COUNTRY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_DESTINATION_COUNTRY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_DESTINATION_COUNTRY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterDestinationCountryReducer;